import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col sm={6}></Col>
            <Col sm={6}>
              <div className="text-sm-end d-none d-sm-block">
                &copy; {new Date().getFullYear()} Khozi. Desenvolvido pela{" "}
                <a
                  href="http://casco.co.mz/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  CASCO
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
